import "./CancelVerification.html";
import "./CancelVerification.scss";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import CancelVerificationComponentController from "./CancelVerificationComponentController";

export class CancelVerificationComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {};
        this.controller = CancelVerificationComponentController;
        this.templateUrl = "/App/Modules/Auth/Components/UserVerification/Cancel/CancelVerification.html";
    }
}
